const verificaDniInitialState = {
    verificaDni: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default verificaDniInitialState;
  